import { OrgDetailType } from '../../../../services/generated/graphql-types';
import { CALLOSUM_BASE_PATH } from '../org-management.utils';
export { CALLOSUM_BASE_PATH };
export const DETAIL_BATCH_SIZE = 50;
export var DetailTab;
(function (DetailTab) {
    DetailTab["USERS"] = "users";
    DetailTab["GROUPS"] = "groups";
    DetailTab["FEATURE_FLAGS"] = "featureFlags";
})(DetailTab || (DetailTab = {}));
export const TAB_TYPE_MAP = {
    [DetailTab.USERS]: OrgDetailType.User,
    [DetailTab.GROUPS]: OrgDetailType.UserGroup,
    [DetailTab.FEATURE_FLAGS]: OrgDetailType.FeatureFlag,
};
const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21)
        return 'th';
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
export const formatDate = (millis) => {
    const date = new Date(millis);
    const day = date.getUTCDate();
    const month = date.toLocaleDateString(undefined, {
        month: 'long',
        timeZone: 'UTC',
    });
    const year = date.getUTCFullYear();
    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
};
//# sourceMappingURL=org-detail-modal.utils.js.map